"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productPanel = _interopRequireDefault(require("./productPanel"));
var _disclosure = _interopRequireDefault(require("./disclosure"));
var _currentPlan = _interopRequireDefault(require("./currentPlan"));
var _planRevisor = require("./planRevisor");
var _header = _interopRequireDefault(require("./header"));
var _excluded = ["application", "offers", "payees", "onCancel", "maxPayeeCount"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FIXED_RATE_PLANS = ['IL', 'LCFRP', 'LCTNI'];
var Main = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Main, _React$Component);
  var _super = _createSuper(Main);
  function Main() {
    var _this;
    (0, _classCallCheck2.default)(this, Main);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      offers: (0, _toConsumableArray2.default)(_this.props.offers),
      selectedRadio: null,
      selectedOfferId: null,
      changeAmount: 0 || _this.props.application && _this.props.application.loanAmount || _this.props.application.amount,
      payeeAmounts: {},
      payeeCount: 0,
      additionalProvider: null,
      hasSubmitted: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOfferSelection", function (e) {
      _this.setState({
        selectedRadio: e.target.attributes,
        selectedOfferId: e.target.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmission", function () {
      var _this$props = _this.props,
        submitRevisions = _this$props.actions.submitRevisions,
        applicationId = _this$props.application.id,
        payees = _this$props.payees;
      var _this$state = _this.state,
        planId = _this$state.selectedOfferId,
        amount = _this$state.changeAmount,
        payeeAmounts = _this$state.payeeAmounts,
        payeeCount = _this$state.payeeCount,
        productType = _this$state.selectedRadio.productType;
      var params = {
        planId: planId,
        applicationId: applicationId,
        amount: amount,
        productType: productType.value.toUpperCase()
      };
      if (payeeCount > 1) {
        params.payees = Object.keys(payeeAmounts).map(function (c) {
          return {
            clientId: c,
            payeeAmount: payeeAmounts[c]
          };
        });
      }
      _this.setState({
        hasSubmitted: true
      }, function () {
        if (payees && payees.length > 1) {
          !payees.some(function (_ref) {
            var id = _ref.id,
              clientId = _ref.clientId;
            return !payeeAmounts[id || clientId];
          }) && submitRevisions({
            params: params
          });
        } else {
          submitRevisions({
            params: params
          });
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleAddProvder", function () {
      var addProvider = _this.props.addProvider;
      var payeeCount = _this.state.payeeCount;
      _this.setState({
        payeeCount: payeeCount + 1
      }, function () {
        return addProvider();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRemoveProvider", function (clientId) {
      var removeProvider = _this.props.removeProvider;
      var payeeAmounts = _objectSpread({}, _this.state.payeeAmounts);
      var payeeCount = _this.state.payeeCount - 1;
      delete payeeAmounts[clientId];
      _this.setState({
        payeeAmounts: payeeAmounts,
        payeeCount: payeeCount,
        changeAmount: 0
      }, function () {
        return removeProvider(clientId);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleAmountChange", function (isMultiProviderFlow, options) {
      var _this$props2 = _this.props,
        fetchOffers = _this$props2.actions.fetchOffers,
        payees = _this$props2.payees;
      var amount = options.amount,
        clientId = options.clientId;
      if (isMultiProviderFlow) {
        var payeeAmounts = _objectSpread({}, _this.state.payeeAmounts);
        payeeAmounts[clientId] = amount;
        var changeAmount = Object.values(payeeAmounts).reduce(function (total, amount) {
          return total + amount;
        }, 0);
        var secClientId = null;
        if (payees.count > 1 || Object.keys(payeeAmounts).length > 1) {
          secClientId = payees[1].clientId || payees[1].id || Object.keys(payeeAmounts)[1];
        }
        if (!isNaN(changeAmount)) {
          _this.setState({
            changeAmount: changeAmount,
            payeeAmounts: payeeAmounts,
            selectedOfferId: null,
            selectedRadio: null
          }, function () {
            return fetchOffers({
              changeAmount: changeAmount,
              secClientId: secClientId
            });
          });
        }
      } else {
        _this.setState({
          changeAmount: amount,
          selectedOfferId: null,
          selectedRadio: null
        }, function () {
          return fetchOffers({
            changeAmount: amount
          });
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasValidOffers", function (offers, changeAmount, isMA_FRPLoan) {
      var maxAmount = _this.getMaximumAmount(offers);
      if (isMA_FRPLoan) {
        return offers.length > 0 && parseFloat(changeAmount) <= parseFloat(maxAmount) && parseFloat(changeAmount) >= parseFloat(_planRevisor.MIN_MASSACHUSETTS_AMT);
      }
      return offers.some(function (_ref2) {
        var isValid = _ref2.isValid;
        return isValid;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMaximumAmount", function (offers) {
      return offers.reduce(function (max, _ref3) {
        var maximumAmount = _ref3.maximumAmount;
        return parseInt(maximumAmount, 10) > parseInt(max, 10) ? maximumAmount : max;
      }, '0');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMinimumAmount", function (offers) {
      return offers.reduce(function (min, _ref4) {
        var minimumAmount = _ref4.minimumAmount;
        return parseInt(minimumAmount, 10) < parseInt(min, 10) ? minimumAmount : min;
      }, '99999');
    });
    return _this;
  }
  (0, _createClass2.default)(Main, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var payees = prevProps.payees;
      var payeeCount = prevState.payeeCount;
      if (payees.length > 0 && payeeCount === 0) {
        var count = 0;
        var payeeAmounts = payees.reduce(function (collection, payee) {
          var clientId = payee.clientId,
            id = payee.id,
            payeeAmount = payee.payeeAmount;
          var payeeId = clientId || id;
          var amount = parseInt(payeeAmount.replace(/[\$|\,]/, ''), 10);
          collection[payeeId] = amount;
          count++;
          return collection;
        }, {});
        this.setState({
          payeeAmounts: payeeAmounts,
          payeeCount: count
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        application = _this$props3.application,
        offers = _this$props3.offers,
        payees = _this$props3.payees,
        onCancel = _this$props3.onCancel,
        maxPayeeCount = _this$props3.maxPayeeCount,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
      var _this$state2 = this.state,
        selectedRadio = _this$state2.selectedRadio,
        selectedOfferId = _this$state2.selectedOfferId,
        payeeAmounts = _this$state2.payeeAmounts,
        changeAmount = _this$state2.changeAmount,
        hasSubmitted = _this$state2.hasSubmitted;
      var displayName = application.recipientName || "".concat(application.firstName, " ").concat(application.lastName);
      var physicalState = application.physicalState,
        _application$mailingA = application.mailingAddressState,
        mailingAddressState = _application$mailingA === void 0 ? '' : _application$mailingA;
      var isMAFRPLoan = [physicalState, mailingAddressState].includes('MA') && FIXED_RATE_PLANS.includes(application.productType);
      var hasValidOffers = this.hasValidOffers(offers, changeAmount, isMAFRPLoan);
      var isFormValid = !!selectedOfferId && hasValidOffers;
      var minAmount = this.getMinimumAmount(offers);
      var maxAmount = this.getMaximumAmount(offers);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "revisions-main-content revisions-main fluid-container"
      }, /*#__PURE__*/_react.default.createElement(_header.default, {
        displayName: displayName,
        onCancel: onCancel
      }), /*#__PURE__*/_react.default.createElement(_currentPlan.default, application), /*#__PURE__*/_react.default.createElement(_planRevisor.PlanRevisor, {
        hasSubmitted: hasSubmitted,
        maxPayeeCount: maxPayeeCount,
        application: application,
        payeeAmounts: payeeAmounts,
        changeAmount: parseFloat(changeAmount),
        payees: payees,
        onAmountChange: this.handleAmountChange,
        removeProvider: this.handleRemoveProvider,
        addProvider: this.handleAddProvder,
        hasValidOffers: hasValidOffers,
        isMAFRPLoan: isMAFRPLoan,
        minAmount: minAmount,
        maxAmount: maxAmount
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, offers.length ? /*#__PURE__*/_react.default.createElement(_productPanel.default, Object.assign({}, rest, {
        hasSubmitted: hasSubmitted,
        application: application,
        offers: offers,
        onConfirmation: this.handleSubmission,
        selectedOfferId: selectedOfferId,
        selectedRadio: selectedRadio,
        onSelection: this.handleOfferSelection,
        productType: application.productType,
        isFormValid: isFormValid
      })) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement(_disclosure.default, Object.assign({}, this.props, {
        productType: application.productType
      }))));
    }
  }]);
  return Main;
}(_react.default.Component);
Main.defaultProps = {
  offers: [],
  payees: []
};
Main.propTypes = {
  maxPayeeCount: _propTypes.default.number,
  application: _propTypes.default.object,
  offers: _propTypes.default.array,
  currentOffer: _propTypes.default.object,
  constants: _propTypes.default.object,
  disclosures: _propTypes.default.object,
  payees: _propTypes.default.array,
  onCancel: _propTypes.default.func,
  addProvider: _propTypes.default.func,
  removeProvider: _propTypes.default.func,
  actions: _propTypes.default.object
};
var _default = Main;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');